import { RouteConfig } from 'vue-router';

import store from '@/store/store';

export const logoutRoute: RouteConfig = {
  path: '/logout',
  name: 'logout',
  beforeEnter: (to, from, next) => {
    store.dispatch('auth/logout');
    next('login');
  }
};
